<template lang="html">
	<div class="om-page" :class="classes">
		<common-review-bar />
		<common-notifications />
		<h1 v-if="title">{{ title }}</h1>
		<slot><p>Page content goes here...</p></slot>
	</div>
</template>

<script lang="js">
export default {
	name: 'CorePage',
	props: {
		title: {
			type: String,
			default: '',
		},
		classes: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">
.om-page {
	padding: 30px 40px 0;
}
</style>
